import Marquee from "react-fast-marquee";

const items = [
  "Land Clearing",
  "Excavation",
  "Dirt Work",
  "Gravel Driveways",
  "House Pads",
  "Tree Removal",
  "Trenching",
  "Grading",
];

export const EditorialMarquee = () => {
  return (
    <section
      className="relative bg-[#080D0A] border-y border-[#223026] py-8 md:py-10 overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-black uppercase text-4xl md:text-6xl tracking-tighter mx-8 stroke-text">
              {item}
            </span>
            <span className="text-lime-400 text-3xl md:text-5xl mx-2">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
